import { EmailVerificationStatus } from '@showbie-socrative/socrative-utils';

import axios from '../localAxios';
import { checkVerificationStatusURL } from './url';

export interface VerificationDataResponse {
  verificationStatus: EmailVerificationStatus;
  email: string;
  newEmail: string | null;
}

export async function getVerificationData(): Promise<VerificationDataResponse> {
  const url = checkVerificationStatusURL();
  const result = await axios.get<VerificationDataResponse>(url.href);
  return result.data;
}
